import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import './styles/theme.css';
import './styles/app.css';
import './styles/print.css';
import { App } from './App';
import { KontextmenueHost } from './ui/Kontextmenue';
import { serviceWorkerRegistrieren } from './pwa/registrieren';
import { tooltipsEinrichten } from './ui/tooltip';

// Logos für Oberfläche und Exporte (PDF, Word, PNG lesen sie aus window.__PA_ASSETS__)
(window as unknown as { __PA_ASSETS__: unknown }).__PA_ASSETS__ = {
  iwm: '/iwm_logo.png',
  iwmDark: '/iwm_logo_dunkel.png',
  iwmRatio: 1.8,
};

createRoot(document.getElementById('app')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
      {/* Eigenes Kontextmenü in der ganzen App (auch Anmelde- und Fehlerseite) */}
      <KontextmenueHost />
    </BrowserRouter>
  </StrictMode>,
);

serviceWorkerRegistrieren();
tooltipsEinrichten();
